// extracted by mini-css-extract-plugin
export default {"gototop":"gototop_gototop__cMI7Z","gototopActive":"gototop_gototopActive__7CbOd"};